import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { CommonConstant } from 'src/app/constants/common-constant';
import { QuestionSetModel } from 'src/app/models/questionSetModel';
import { CommonService } from 'src/app/services/common/common.service'; 
import { DirtycheckDialogboxComponent } from '../../dirtycheck-dialogbox/dirtycheck-dialogbox.component';
import { QuestionSetConstant } from 'src/app/constants/label-constants';
import { questionErrorPageMessage } from 'src/app/constants/error-message-constant';

@Component({
  selector: 'app-question-set-add-edit',
  templateUrl: './question-set-add-edit.component.html',
  styleUrls: ['./question-set-add-edit.component.scss']
})
export class QuestionSetAddEditComponent {
  QuestionSetForm: FormGroup = this.formBuilder.group({});
  QuestionSetId:number =0;
  modalButton: boolean = false;
  CommonConstant:any=[];
  QuestionSetConstant:any=[];
  errorMessage:any=[];
  flag:boolean= true;

  constructor(
    private formBuilder: FormBuilder,
    private CommonService: CommonService,
    private toastr: ToastrService,
    private apiUrl: ApiUrlHelper,
    private spinner: NgxSpinnerService,
    public modalService: NgbActiveModal,
    public ModalService: NgbModal,
  ) { }

  ngOnInit(): void {
    this.CommonConstant = CommonConstant;
    this.errorMessage=questionErrorPageMessage;
    this.QuestionSetConstant = QuestionSetConstant;
    this.onInitQuestionSetForm();
    if (this.QuestionSetId > 0) {
      this.spinner.show();
      this.flag = false;
      this.getQuestionSetDetail(this.QuestionSetId);
    }
    else {
      this.QuestionSetId = 0;
    }
  }

  onInitQuestionSetForm() {
    this.QuestionSetForm = this.formBuilder.group({
      QuestionSetId: [0],
      QuestionSetName: ['', [Validators.required , Validators.maxLength(100)]]
    });
  }
  
  get questionSetFormControl() {
    return this.QuestionSetForm.controls;
  }

  getQuestionSetDetail(QuestionSetId: number) { 
    const apiUrl = this.apiUrl.apiUrl.QuestionSet.GetQuestionSetById.replace("{id}", QuestionSetId.toString());
    this.CommonService.doGet(apiUrl).pipe().subscribe({
      next: (data) => {
        this.setQuestionSetForm(data.data[0]);
        this.spinner.hide();
        this.flag = true;
      },
      error: (err) => {
        console.log('getGetRoleById-Error', err);
      }
    });
  }

  setQuestionSetForm(data: QuestionSetModel) {
    this.QuestionSetForm.setValue({
      QuestionSetId:(data.questionSetId)?data.questionSetId:0,
      QuestionSetName: data.questionSetName
    });
  }

  saveQuestionSet(){
    this.modalButton = true;
    if (!this.QuestionSetForm.valid) {
      return;
    }
    this.spinner.show();
    const objData: QuestionSetModel = {
      questionSetId: !this.QuestionSetForm.value.QuestionSetId ? 0 : this.QuestionSetForm.value.QuestionSetId,
      questionSetName: this.QuestionSetForm.value.QuestionSetName.trim()
    }
    const apiUrl = this.apiUrl.apiUrl.QuestionSet.SaveQuestionSet;
    this.CommonService.doPost(apiUrl, objData).pipe().subscribe({
      next: (data) => {
        if (data.success) {
          this.modalButton = false;
          this.spinner.hide();
          this.modalService.close('save');
          this.toastr.success(data.message);
        }
        else {
          this.spinner.hide();
          this.toastr.error(data.message);
        }
      },
      error: (er) => {
        console.error(er)
      }
    });
  }
  
  onCancel(){
    if (this.QuestionSetForm.dirty) {
      const modalRef = this.ModalService.open(DirtycheckDialogboxComponent, { centered: true, backdrop: 'static', keyboard: false });
      modalRef.componentInstance.QuestionSetForm = this.QuestionSetForm;
    }
    else{
      this.modalService.close();
    }
  }
}
